import "./FavoriteLinks.css";

export default function FavoriteLinks({ favorites }) {
  return (
    <div className="link-grid">
      {favorites.map((fav) => (
        <div key={fav.linkid} className="link-card">
          <h3>{fav.description}</h3>
          <p className="link-meta">
            登録日: {new Date(fav.createdate).toLocaleDateString()}
          </p>
          <a
            href={fav.url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-button"
          >
            🔗 リンクを開く
          </a>
        </div>
      ))}
    </div>
  );
}